<ui-title [title]="'System Roles & SOD'">
	<div class="col-lg-6 float-right" [hidden]="!roles.loading">
		<ui-loading [loadingText]="'loading roles'" [loading]="true"></ui-loading>
	</div>
</ui-title>

<ui-alert
		*ngIf="modalAlert.display"
		[title]="modalAlert.title"
		[text]="modalAlert.text"
		(onAction)="modalAlert.cb($event)"
	></ui-alert>

<div class="col-lg-12">

	<div class="alert alert-warning pb-0 pt-0" *ngIf="roles.unmappedCount">{{roles.unmappedCount}} unmapped roles</div>

	<ui-table #table [chunker]="roles.chunker" (chunked)="roles.chunkedData = $event" [headers]="roles.tableHeaders" [filters]="true" [options]="roles.tableOptions">
		<tr *ngFor="let an of roles.chunkedData"
			[class]="roles.selectedId==an.SystemRoleId?'helper-clickable active':'helper-clickable'"
			(click)="roles_select(an)"
		>
			<td style="width:110px">{{an.SystemName}}</td>
			<td style="width:350px">
				<span *ngIf="an.SystemRoleDeprecated===true" class="badge bg-grey">
				deprecated
				</span>
				
				{{an.SystemRoleName}}</td>
			<td>{{an.SystemRoleMappedName}}</td>

			<td style="width:110px">{{an.SystemRoleMappedDate|date}}</td>
			<td style="width:110px">{{an.SystemRoleMappedBy}}</td>
			<td style="width:150px;text-align: center">
				{{an.SystemRoleSODRequired == null ? 'not yet setup' : ''}}
				<span *ngIf="an.SystemRoleSODRequired===true" class="material-icons color-green green " style=" position:absolute;   margin-left: -12px;margin-top: -1px;">
				done
				</span>

				<span *ngIf="an.SystemRoleSODRequired===false" class="material-icons color-red red" style="   position:absolute; margin-left: -12px;margin-top: -1px;">
				close
				</span>
			</td>
			<td style="width:65px">
				{{an.ClashesCount}}
			</td>
			<td style="width:75px">
				<span *ngIf="an.SystemRoleMappedName" class="material-icons color-green green" style=" position:absolute;   margin-left: 23px;margin-top: -1px;">
				done
				</span>

				<span *ngIf="!an.SystemRoleMappedName" class="material-icons color-red red" style="   position:absolute; margin-left: 23px;margin-top: -1px;">
				close
				</span>
			</td>
		</tr>
	</ui-table>
</div>


<div class="col-lg-12 mt-4" *ngIf="roles.selectedId">
	<div class="card">
		<div class="card-header">
			<h2>

				{{roles.selected.SystemRoleName}}

				<small style="font-size: 12px;">
				{{roles.selected.SystemName}}  role</small>
			</h2>
		</div>
		<div class="card-body ">
			<div class="card">
				<div class="card-header">Updating Role</div>
				<div class="card-body" [hidden]="!roles.saving">
					<ui-loading [loading]="true"></ui-loading>
				</div>
				<div class="card-body" [hidden]="roles.saving" style="margin-bottom: 20px;">
					<div class="form-group row mt-3">
						<label class="col-lg-2">
							Standard Role Name
						</label>
						<div class="col-lg-10">
							<input type="text" class="form-control" [(ngModel)]="roles.selected.SystemRoleMappedName" placeholder="Standard Role Name">
						</div>
					</div>
					<div class="form-group row mt-3">
						<label class="col-lg-2">
							Description <small class="color-orange">(optional)</small>
						</label>
						<div class="col-lg-10">
							<input type="text" class="form-control" [(ngModel)]="roles.selected.SystemRoleDescription" placeholder="Description">
						</div>
					</div>
					<div class="form-group row mt-3">
						<label class="col-lg-2">
							Deprecated?
						</label>
						<div class="col-lg-10">
							<mat-checkbox [(ngModel)]="roles.selected.SystemRoleDeprecated" [checked]="roles.selected.SystemRoleDeprecated" color="primary"></mat-checkbox>
							(role is no longer used but will still appear on older reports)
						</div>
					</div>
					<div class="form-group row mt-3">
						<label class="col-lg-2">
							SOD rule(s) required?
						</label>
						<div class="col-lg-10">
							<mat-checkbox [(ngModel)]="roles.selected.SystemRoleSODRequired" [checked]="roles.selected.SystemRoleSODRequired" color="primary"></mat-checkbox>

							<button *ngIf="roles.selected.SystemRoleMappedName" mat-button class="btn-danger float-right" (click)="roles_remove()" style="position: absolute;    right: 90px;margin-top: 15px;">
								Unmap
							</button>
							<button mat-button class="float-right {{roles.selected && length(roles.selected.SystemRoleMappedName)>3?'btn-primary':'btn-disabled'}}" (click)="roles_save()" style="position: absolute;    right: 15px;margin-top: 15px;">
								Apply
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="card-separator"></div>

			<div class="card" >
				<div class="card-header">SOD Roles clashing with this role</div>
				<div class="card-body" [hidden]="!roles.loadingClashes && !roles.addingClash">
					<ui-loading></ui-loading>
				</div>
				<div class="card-body" [hidden]="roles.loadingClashes || roles.addingClash">

					<div class="form-group mat-autocomplete-large" [hidden]="roles.loadingClashes">
						<ui-loading [loading]="roles.loadingClashes"></ui-loading>

						<div class="row">
							<div class="col-lg-8">
									<ui-input-autocompleter
										#autocompleterRoles
										[text]="'Search Role'"
										[controller]="self"
										[autocompleteDisplay]="autocompleteDisplaySelectedRole"
										[searchObservable]="search_roles"
								></ui-input-autocompleter>

							</div>
							<div class="col-lg-4">
								<button style="margin-left: 5px"
										mat-button class=" bg-blue-important white-important  btn-primary"
										(click)="role_addClash();$event.preventDefault()">Define clash with this rule
								</button>
							</div>
						</div>
					</div>


					<div class="form-group ">
						<ui-table [headers]="[
						{label:'System'},
						{label:'Standard Role Name'},
						{label:'Role Name'},
						{label:'Definition By'},
						{label:'Definition Date'},
						{label:''}
						]"
								  [chunker]="roles.clashesChunker"
								  [options]="{noToolbar:true}"
						>
							<tr *ngFor="let option of roles.clashes">
								<td>{{option.ClashWithSystemName}}</td>
								<td>{{option.ClashWithSystemRoleMappedName}}</td>
								<td>{{option.ClashWithSystemRoleName}}</td>
								<td>{{option.ClashWithCreatedBy}}</td>
								<td>{{option.ClashWithCreatedDate|date}}</td>
								<td class="" style="padding: 6px">
									<ui-loading [loading]="roles.deletingClashWith[option.Id]"></ui-loading>
									<button *ngIf="!roles.deletingClashWith[option.Id]" (click)="roles_removeClashWith(option)" class="btn btn-sm  btn-danger">remove</button>
								</td>
							</tr>
						</ui-table>
					</div>
				</div>
			</div>

			<div class="card-separator"></div>

			<div class="card">
				<div class="card-header">Use in Batches</div>
				<div class="card-body" [hidden]="!roles.loadRoleBatchs">
					<ui-loading></ui-loading>
				</div>
				<div class="card-body row" [hidden]="roles.loadRoleBatchs" *ngIf="roles.roleBatchs[0]">
					<div class="form-group col-lg-4">
						<div class="form-control-label col-lg-6">First Reported</div>
						<div class="form-control-label col-lg-6">
							{{roles.roleBatchs[0]|date}}
						</div>
					</div>
					<div class="form-group  col-lg-4">
						<div class="form-control-label col-lg-6">Last Reported</div>
						<div class="form-control-label col-lg-6">{{roles.roleBatchs[1]|date}}</div>
					</div>
				</div>
				<div class="card-body" [hidden]="roles.loadRoleBatchs" *ngIf="!roles.roleBatchs[0]">
					<p class="alert alert-warning">This role has not yet been found in any batch</p>
				</div>
			</div>

			<div class="card-separator"></div>

			<div class="card">
				<div class="card-header">Logs</div>
				<div class="card-body" [hidden]="!roles.loadAuditLogs">
					<ui-loading></ui-loading>
				</div>
				<div class="card-body" [hidden]="roles.loadAuditLogs">
					<ui-table [headers]="[
						{label:'Date'},
						{label:'Log'}
						]"
							  [chunker]="roles.auditLogsChunker"
							  [options]="{noToolbar:true}"
					>
						<tr *ngFor="let option of roles.auditLogs">
							<td>{{option.CreatedDate|date}} {{option.DateCreated|hoursandminutes}}</td>
							<td>{{option.Log}}</td>
						</tr>
					</ui-table>
				</div>
			</div>



		</div>
	</div>
</div>
